const firebase = require('firebase/app');
// Required for side-effects
require('firebase/firestore');
require('firebase/storage');
// Initialize Cloud Firestore through Firebase

firebase.initializeApp({
  apiKey: process.env.FB_API_KEY,
  authDomain: process.env.FB_AUTH_DOMAIN,
  projectId: process.env.FB_PROJECTID,
  storageBucket: process.env.STORAGE_BUCKET,
});

const firestoreDB = firebase.firestore();

const storage = firebase.storage();

export { firebase, firestoreDB, storage };



// WEBPACK FOOTER //
// ./src/assets/js/firebase.js